
import UploadPictures from '../uploadPictures/index.jsx'
import SetColor from '../setColor/index.jsx'
import './side.less'
import React from 'react'
import Slider from '../slider/index.jsx'
console.log(React)
export default function TopRotationSide(props) {
  return (<div className='TopRotationSide'>
    <div className='TopRotationSide_no1'>
      <h3 className='no1_title'>轮播图</h3>
      <div className='no1_box'>
        {props.ifon.image_id_list.map((item) => {
          return <div className='box_item'>
            <img className='item_img' src={item.src} />
            <i className='item_icon'>X</i>
          </div>
        })}
        {props.ifon.image_id_list.length < 5 && <UploadPictures change={(e) => {
          uploadPictures(props, e)
        }}></UploadPictures>}

      </div>
      <span className='no1_tips'>图片要求：png/jpg/jpeg/gif,小于3M, 最大1080*1920, 图片宽高比需统一, 最多5张</span>
    </div>
    <div className='TopRotationSide_no2'>
      <h3 className='no2_title'>轮播图样式</h3>
      <div className='no2_box'>
        <div className='box_item'>
          <span className='item_title'>播放方式</span>
          <div className='box'>
            <ul className='box_ul' onClick={(e) => {
              if (!e.target.dataset.index) {
                return
              }
              props.ifon.type = parseFloat(e.target.dataset.index)
              props.mySetIfon(props.ifon)
            }}>
              <li className={`ul_li ${props.ifon.type === 0 ? 'active' : ''}`} data-index={0}>平滑滚动</li>
              <li className={`ul_li ${props.ifon.type === 1 ? 'active' : ''}`} data-index={1}>居中轮播</li>
              <li className={`ul_li ${props.ifon.type === 2 ? 'active' : ''}`} data-index={2}>淡入淡出</li>
              <li className={`ul_li ${props.ifon.type === 3 ? 'active' : ''}`} data-index={3}>3D旋转</li>
              <li className={`ul_li ${props.ifon.type === 4 ? 'active' : ''}`} data-index={4}>3D滚动</li>
            </ul>
          </div>
        </div>

        <div className='box_item'>
          <span className='item_title'>播放速度</span>
          <Slider minValue={1} maxValue={5} defaultValue={1} change={(value) => {
            props.ifon.playbackSpeed = value * 500
            props.mySetIfon(props.ifon)
          }}>播放速度</Slider>
        </div>

        <div className='box_item'>
          <span className='item_title'>背景</span>
          <div className='box'>
            <ul className='box_ul' onClick={(e) => {
              if (!e.target.dataset.index) {
                return
              }
              props.ifon.backType = parseFloat(e.target.dataset.index)
              props.mySetIfon(props.ifon)
            }}>
              <li className={`ul_li ${props.ifon.backType === 0 ? 'active' : ''}`} data-index={0}>纯色背景</li>
              <li className={`ul_li ${props.ifon.backType === 1 ? 'active' : ''}`} data-index={1}>图片背景</li>
            </ul>
          </div>
        </div>

        {props.ifon.backType === 1 ? <div className='box_item'>
          <span className='item_title'>上传背景</span>
          {props.ifon.backImage.src ? null : <UploadPictures change={(e) => {
            uploadPictures1(props, e)
          }}></UploadPictures>}
          {props.ifon.backImage.src ? <div className='itemB'>
            <img className='itemB_img' src={props.ifon.backImage.src} />
            <i className='itemB_icon'>X</i>
          </div> : null}
        </div> : null}

        {props.ifon.backType === 0 ? <div className='box_item'>
          <span className='item_title'>背景颜色</span>
          <div className='ccc'>
            <SetColor setColor={(obj) => {
              props.ifon.back = obj.hex
              props.mySetIfon(props.ifon)
            }}></SetColor>
          </div>
        </div> : null}

        <div className='box_item'>
          <span className='item_title'>边距</span>
          <div className='box'>
            <div className='item'>
              <Slider maxValue={50} change={(value) => {
                props.ifon.paddingTop = value
                props.mySetIfon(props.ifon)
              }}>上</Slider>
            </div>
            <div className='item'>
              <Slider maxValue={50} change={(value) => {
                props.ifon.paddingBottom = value
                props.mySetIfon(props.ifon)
              }}>下</Slider>
            </div>
            <div className='item'>
              <Slider maxValue={100} change={(value) => {
                props.ifon.paddingLeft = value
                props.mySetIfon(props.ifon)
              }}>左</Slider>
            </div>
            <div className='item'>
              <Slider maxValue={100} change={(value) => {
                props.ifon.paddingRight = value
                props.mySetIfon(props.ifon)
              }}>右</Slider>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>)
}

function uploadPictures(props, e) {
  const src = window.URL.createObjectURL(e.file)
  props.ifon.image_id_list.push({
    fileIfon: e.file,
    src,
    id: Math.random()
  })
  props.mySetIfon(props.ifon)
}

function uploadPictures1(props, e) {
  const src = window.URL.createObjectURL(e.file)
  props.ifon.backImage = {
    fileIfon: e.file,
    src,
    id: Math.random()
  }
  props.mySetIfon(props.ifon)
}
